import type { ChildrenProps } from "helpers";
import type { BrowserHistory } from "history";
import type React from "react";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
import { useAppStore } from "src/state/appStore";

interface AegisBrowserRouterProps extends ChildrenProps {
	history: BrowserHistory;
}

const AegisBrowserRouter: React.FC<AegisBrowserRouterProps> = ({ children, history }) => {
	const tenantName = useAppStore(s => s.tenantName);

	return (
		<HistoryRouter history={history} basename={tenantName}>
			{children}
		</HistoryRouter>
	);
};

export default AegisBrowserRouter;